import React, { useContext, useEffect, useState } from 'react';
import Grid, { GridSpacing } from '@material-ui/core/Grid';

import MeasureLogGrid from './MeasureLogGrid';
import MeasureLogGridIoTBox from './MeasureLogGridIoTBox';
import { AppContext } from '../../../App';
import MeasureLogFooter from './MeasureLogFooter';
import { MeasureLogStyle } from './MeasureLogStyle';
import { GetMeasureModel, MeasureLogDataType } from './MeasureLog';
import ImageDialog, { ImageDialogResponse } from '../../molecules/Dialog/ImageDialog';
import { useModal } from '../../../function/useModal';
import { ImageFileType, GetThreeDimensionImagePath, GetThreeDimensionImageTitle } from '../../../function/ImageFileModel';
import { useTranslation } from 'react-i18next';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import Typography from '@material-ui/core/Typography';
import { CollectSettingItemDialogResponse } from '../MeasureSetting/CollectSetting/CollectSettingItemDialog';
import { PLCcollectSettingType } from '../MeasureSetting/CollectSetting/CollectSettingDefine';

const MeasureLogPage: React.FC = () => {
  const { t } = useTranslation();
  const pageStyle = MeasureLogStyle();
  const { login } = useContext(AppContext);

  const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');
  const [imagePath, setImagePath] = React.useState<string>('');
  const [imageName, setImageName] = React.useState<string>('');
  const [imageDlg, actImageDlg] = useModal<ImageDialogResponse>();
  const [imageCollectSetting, setImageCollectSetting] = React.useState<PLCcollectSettingType>();
  const [imageFileDate, setImageFileDate] = React.useState<string>('');
  const [selectData, setSelectData] = useState({
    plcNo: '',
    aiCardNo: '',
    aiChannelNo: '',
    selectDate: '',
  });

  const imgDlg = imageDlg ? (
    <ImageDialog
      dialog={actImageDlg}
      imageName={imageName}
      imagePath={imagePath}
      imageWidht={'100%'}
      imageHeigth={'100%'}
      title={GetThreeDimensionImageTitle(imageFileDate, imageCollectSetting)}
    />
  ) : null;

  /**
   *選択内容変更
   * @param value
   */
  const onSelectDataChange = (plcNo: string, aiCardNo: string, aiChannelNo: string, selectDate: string) => {
    selectData.plcNo = plcNo;
    selectData.aiCardNo = aiCardNo;
    selectData.aiChannelNo = aiChannelNo;
    selectData.selectDate = selectDate;
  };
  /**メッセージボックス閉じる */
  const handleSimpleDialogClose = () => {
    setSimpleDialogOpen(false);
  };

  /**
   *３次元グラフ表示ダイアログ表示
   * @returns
   */
  const dispImageFileAction = () => {
    //選択項目を取得
    if (selectData.plcNo === '') {
      setShowMessage(t('MeasureLogPage.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }
    GetThreeDimensionImagePath(selectData.plcNo, selectData.aiCardNo, selectData.aiChannelNo, selectData.selectDate, 0)
      .then((r) => {
        if (r.FilePath === '') {
          setShowMessage(t('MeasureLogPage.ファイルがありません', 'ファイルがありません') + '\n' + r.SearchFileName);
          setSimpleDialogOpen(true);
        } else {
          setImageName(r.FilePath);
          setImagePath(`data:image/bmp;base64,${r.Base64ImageData}`);
          setImageCollectSetting(r.CollectSettingModel);
          setImageFileDate(r.FileDate);
          actImageDlg
            .open()
            .apply((resp: ImageDialogResponse) => {})
            .cancel(() => {});
        }
      })
      .catch((error) => {
        setShowMessage(
          t('MeasureLogPage.ファイル取得中ににエラーが発生しました', 'ファイル取得中ににエラーが発生しました')
        );
        setSimpleDialogOpen(true);
      })
      .finally(() => {});
  };

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center">
        <Grid item xs={12}>
          {login.IsIoT ? (
            <MeasureLogGridIoTBox onChangeData={onSelectDataChange} />
          ) : (
            <MeasureLogGrid onChangeData={onSelectDataChange} />
          )}
        </Grid>
        <Grid item xs={12}>
          <MeasureLogFooter buttonEnable={true} onClickDispImageFile={dispImageFileAction}></MeasureLogFooter>
        </Grid>
      </Grid>
      <SimpleDialog
        open={simpleDialogOpen}
        onClose={handleSimpleDialogClose}
        title={t('MeasureLogPage.計測一覧', '計測一覧')}
        okText={t('MeasureLogPage.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
      {imgDlg}
    </>
  );
};

export default MeasureLogPage;
